import React from 'react';

const PassportValidationError = ({ validationErr }) => {
  const errorLines = validationErr.split('\n');
  const hasRecommendations = validationErr.includes('המלצות לתיקון:');
  
  // Get the main error message (everything before recommendations)
  const mainError = hasRecommendations 
    ? errorLines.slice(1, errorLines.findIndex(line => line.includes('המלצות לתיקון:'))).join(' • ').replace(/•/g, '')
    : errorLines.slice(1).join(' • ').replace(/•/g, '');
  
  // Get recommendations if they exist
  const recommendations = hasRecommendations 
    ? validationErr.split('המלצות לתיקון:')[1]
        .replace(/\n•/g, ', ')
        .replace(/•/g, '')
        .replace(/,\s*,/g, ',') // Remove duplicate commas
        .replace(/^,\s*/, '') // Remove leading comma
        .replace(/,\s*$/, '') // Remove trailing comma
        .trim()
    : 'העלה תמונה ברורה של הדרכון המלא';

  return (
    <div className="passport-validation-error" style={styles.container}>
      {/* Background decoration */}
      <div style={styles.backgroundDecoration} />
      
      <div style={styles.iconContainer}>
        <span style={styles.iconText}>!</span>
      </div>
      
      <div style={styles.contentContainer}>
        <div style={styles.title}>
          תמונת הדרכון לא תקינה
        </div>
        
        {mainError && (
          <div style={styles.errorMessage}>
            {mainError}
          </div>
        )}
        
        <div style={styles.recommendationsContainer}>
          <span style={styles.lightbulbIcon}>💡</span>
          <span style={styles.recommendationsText}>
            <strong>המלצות:</strong> {recommendations}
          </span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    marginTop: '16px',
    padding: '20px',
    backgroundColor: 'linear-gradient(135deg, #fef7f7 0%, #fef2f2 100%)',
    border: '1px solid #fecaca',
    borderRadius: '12px',
    borderLeft: '4px solid #ef4444',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    position: 'relative',
    overflow: 'hidden'
  },
  
  backgroundDecoration: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    width: '40px',
    height: '40px',
    background: 'radial-gradient(circle, rgba(239, 68, 68, 0.1) 0%, transparent 70%)',
    borderRadius: '50%'
  },
  
  iconContainer: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: '2px',
    boxShadow: '0 2px 4px rgba(239, 68, 68, 0.3)'
  },
  
  iconText: {
    color: 'white',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: 1
  },
  
  contentContainer: {
    flex: 1,
    textAlign: 'right',
    direction: 'rtl',
    fontFamily: 'Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  
  title: {
    color: '#dc2626',
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '12px',
    letterSpacing: '-0.025em',
    lineHeight: '1.3',
    textAlign: 'right'
  },
  
  errorMessage: {
    color: '#7f1d1d',
    fontSize: '15px',
    lineHeight: '1.6',
    marginBottom: '12px',
    backgroundColor: 'rgba(127, 29, 29, 0.05)',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid rgba(127, 29, 29, 0.1)',
    textAlign: 'right',
    direction: 'rtl',
    fontFamily: 'Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  
  recommendationsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    color: '#92400e',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: 'rgba(146, 64, 14, 0.08)',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid rgba(146, 64, 14, 0.15)',
    textAlign: 'right',
    direction: 'rtl',
    fontFamily: 'Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  
  lightbulbIcon: {
    fontSize: '18px',
    flexShrink: 0,
    marginTop: '1px'
  },
  
  recommendationsText: {
    lineHeight: '1.5',
    flex: 1
  }
};

export default PassportValidationError;
